export default __webpack_public_path__ + "static/media/02.aef3d9b7.jpg";